import { render, staticRenderFns } from "./Assessment-Detail.vue?vue&type=template&id=515a1db8"
import script from "./Assessment-Detail.vue?vue&type=script&lang=js"
export * from "./Assessment-Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports